import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

// Fila de ListaAdmin: con href navega (Link), con onClick es botón, sin ninguno solo se muestra.
// antes: algo que va fuera del área clicable, a la izquierda (p. ej. una casilla de selección)
const FilaAdmin = ({ activa, onClick, href, antes, imagen, icono, iniciales, titulo, subtitulo, insignias }) => {
    const clase = 'fila_admin' + (activa ? ' fila_admin_activa' : '');
    const contenido = (
        <Fragment>
            {imagen ? (
                <img className='fila_admin_imagen' src={imagen} alt='' loading='lazy' />
            ) : (
                <span className='fila_admin_avatar'>
                    {icono ? <i className='material-icons'>{icono}</i> : iniciales}
                </span>
            )}
            <span className='fila_admin_texto'>
                <span className='fila_admin_titulo'>{titulo}</span>
                {subtitulo && <span className='fila_admin_subtitulo'>{subtitulo}</span>}
            </span>
            {insignias && <span className='fila_admin_insignias'>{insignias}</span>}
            {(onClick || href) && <i className='material-icons fila_admin_flecha'>chevron_right</i>}
        </Fragment>
    );

    return (
        <li className={antes ? 'fila_admin_con_antes' : undefined}>
            {antes && <span className='fila_admin_antes'>{antes}</span>}
            {href ? (
                <Link to={href} className={clase}>{contenido}</Link>
            ) : (
                <button type='button' className={clase} onClick={onClick} disabled={!onClick}>{contenido}</button>
            )}
        </li>
    );
};

export const Insignia = ({ variante, children }) => (
    <span className={'insignia_admin' + (variante ? ' insignia_admin_' + variante : '')}>{children}</span>
);

export default FilaAdmin;
